<template>
  <v-text 
    :config="textConfig" 
    @mousedown="$emit('mouse:down', $event)"
    @mouseup="$emit('mouse:up', $event)"
    @mouseover="$emit('mouse:over', $event)"
    @mouseout="$emit('mouse:out', $event)"
  />
</template>

<script>
import canvasElement from './mixins/canvasElement'
export default {
  name: 'DrawText',
  mixins: [canvasElement],
  props: {
    text: String,
    color: {
      type: String,
      default: 'black'
    },
    scale: {
      validator (value) {return !isNaN(value)},
      default: 1
    },
    fontFamily: String,
  },
  data () {
    return {}
  },
  computed: {
    textConfig () {
      return {
        ...this.config,
        baseName: this.name,
        text: this.text,
        scaleX: this.scale,
        scaleY: this.scale,
        fill: this.color,
        fontFamily: this.fontFamily,
        rotation: this.rotation,
        draggable: this.draggable,
      }
    }
  }
}
</script>